import React from "react";
import { Link } from "react-router-dom";
import { UserMenu } from "./UserMenu";
import { OrgSwitcher } from "./OrgSwitcher";
import { NotificationsMenu } from "./NotificationsMenu";
import { AdminMenu } from "./AdminMenu";
import logoLong from "@/assets/logo_long.png";

export function Topbar() {
  return (
    <header className="h-14 border-b border-border bg-surface flex items-center px-lg gap-md">
      <Link to="/" className="flex items-center gap-sm shrink-0">
        <img src={logoLong} alt="Krakensense" className="h-7 w-auto" />
      </Link>
      <div className="h-6 w-px bg-border" />
      <OrgSwitcher />
      <div className="flex-1" />
      <div className="flex items-center gap-xs">
        <AdminMenu />
        <NotificationsMenu />
        <div className="h-6 w-px bg-border mx-xs" />
        <UserMenu />
      </div>
    </header>
  );
}
